import Vue from 'vue';
import _ from 'lodash';
import { COMMON_BUS_COMPONENTS_LIST } from '@/constants/commonBusComponentsList';
import { mapGetters } from 'vuex';
var GhostHeightSources;
(function (GhostHeightSources) {
    GhostHeightSources["store"] = "store";
    GhostHeightSources["localStorage"] = "localStorage";
})(GhostHeightSources || (GhostHeightSources = {}));
export default Vue.extend({
    name: 'dropWrapper',
    props: {
        name: {
            type: String,
            required: true
        },
        ghostHeight: {
            type: Number
        },
        ghostHeightSource: {
            type: String,
            default: GhostHeightSources.store
        }
    },
    computed: Object.assign(Object.assign({}, mapGetters('dropData', ['getGhostHeights'])), { currentDroppedItem() {
            const vm = this;
            if (vm.name)
                return _.find(COMMON_BUS_COMPONENTS_LIST, (item) => item.name === vm.name).title;
            return '';
        },
        getGhostHeight() {
            const vm = this;
            const vuexBindHeight = vm.getGhostHeights[vm.name];
            if (vuexBindHeight)
                return vuexBindHeight + 'px';
            if (vm.ghostHeight)
                return vm.ghostHeight + 'px';
            return 'auto';
        } }),
    methods: {
        doRepareFromGateway(name) {
            const vm = this;
            vm.$emit('onRepare');
            vm.$repareFromBrowserGateway(name);
        }
    },
    mounted() {
        const vm = this;
        setTimeout(() => {
            var _a;
            const item = COMMON_BUS_COMPONENTS_LIST.find((item) => item.name === this.name);
            if (item) {
                const height = ((_a = document.getElementById(item.id)) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
                if (height) {
                    vm.$store.commit('dropData/setGhostHeight', { name: vm.name, value: height });
                }
            }
        }, 1000);
    }
});
